"use client";

import {
  Button,
  Card,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Tooltip,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addJobPreferenceAsync,
  fetchJobPreferencesAsync,
  selectJobPreference,
  updateJobPreferenceAsync,
} from "./JobPreferenceSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRupeeSign } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import {
  fetchJobDepartmentsAsync,
  selectJobDepartments,
} from "../../../AdminPanel/JobPostingSlice/JobDepartment/JobDepartmentSlice";
import SpinnerLoad from "../../../common/Spinner";
import {
  fetchPublicCoreLocationsAsync,
  selectPublicCoreLocations,
} from "../../../jobSearch/FetchLocationSlice/FetchLocationSlice";
import EmptyState from "../../components/Tester";
import { FaBriefcase } from "react-icons/fa";
import { fetchCoreSkillsAsync } from "../ITskills/ITskillSlice";
import { selectJobSkills } from "../../../AdminPanel/JobPostingSlice/JobSkillsList/JobSkillsSlice";

function JobPreferences() {
  const dispatch = useDispatch();
  const jobPreferences = useSelector(selectJobPreference);
  const jobDepartments = useSelector(selectJobDepartments);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchJobPreferencesAsync());
    dispatch(fetchJobDepartmentsAsync());
    dispatch(fetchPublicCoreLocationsAsync());
    dispatch(fetchCoreSkillsAsync());
  }, [dispatch]);

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: jobPreferences,
  });

  const handleSave = async (newJobPreference) => {
    setLoading(true);
    try {
      // Ensure skills are included in the job preference data
      const jobPreferenceData = {
        ...newJobPreference,
        preferred_skills: skillsId.length > 0 ? skillsId : [],
        preferred_location: locationId.length > 0 ? locationId : [],
      };

      console.log("Saving job preference data:", jobPreferenceData);

      await dispatch(
        addJobPreferenceAsync({ newJobPreference: jobPreferenceData })
      );
      await dispatch(fetchJobPreferencesAsync());
      onClose1();
      reset();

      toast({
        title: "Job Preferences Added",
        description: "Your job preferences have been successfully added.",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "solid",
      });
    } catch (error) {
      console.error("Failed to add job", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.message ||
          "Failed to add job preferences. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "solid",
      });
    } finally {
      setLoading(false);
    }
  };

  const coreLocation = useSelector(selectPublicCoreLocations);
  const coreSkills = useSelector(selectJobSkills);

  const [location, setLocation] = useState([]);
  const [locationId, setLocationId] = useState([]);
  const [skills, setSkills] = useState([]);
  const [skillsId, setSkillsId] = useState([]);

  // location
  const [selectedLocation, setSelectedLocation] = useState([]);

  const handleSelectedLocation = (e) => {
    const selectedLocationId = e.target.value; // Assuming uuid is a string, no need to parseInt

    console.log("Selected value from <Select>: ", selectedLocationId); // Log the value being passed

    const selectedLocation = coreLocation.find(
      (item) => item.uuid === selectedLocationId // Ensure you're matching `uuid`
    );

    console.log("selected location: ", selectedLocation); // Log the result of the find method

    if (
      selectedLocation &&
      !location.some((loc) => loc.uuid === selectedLocation.uuid) // Compare uuid instead of id
    ) {
      const updatedLocation = [...location, selectedLocation];
      const updatedLocationId = [...locationId, selectedLocation.uuid]; // Use uuid for the id array

      console.log("updatedLocationId: ", updatedLocationId);

      setLocation(updatedLocation);
      setLocationId(updatedLocationId);
      setValue("preferred_location", updatedLocationId); // Reflect the updated location in the form
    }
  };

  const removeLocation = (index) => {
    // Filter out the location to remove it from the list
    const updatedLocation = location.filter((_, i) => i !== index);

    // Update locationId accordingly
    const updatedLocationId = updatedLocation.map((loc) => loc.uuid);

    // Update the state
    setLocation(updatedLocation); // Update the location array
    setLocationId(updatedLocationId); // Update the locationId array
    setValue("preferred_location", updatedLocationId); // Reflect the updated location in the form
  };

  const handleSelectedSkills = (e) => {
    const selectedSkillUuid = e.target.value;
    const selectedSkill = coreSkills?.find(
      (item) => item.uuid === selectedSkillUuid
    );

    if (
      selectedSkill &&
      !skills.some((skill) => skill.uuid === selectedSkill.uuid)
    ) {
      const updatedSkills = [...skills, selectedSkill];
      const updatedSkillIds = updatedSkills.map((skill) => skill.uuid);

      console.log("Updated skills: ", updatedSkills);
      console.log("Updated skills IDs: ", updatedSkillIds);

      setSkills(updatedSkills);
      setSkillsId(updatedSkillIds);
      setValue("preferred_skills", updatedSkillIds); // Ensure this is called correctly
    }
  };

  const removeSkill = (index) => {
    const updatedSkills = skills.filter((_, i) => i !== index); // Remove skill by index
    const updatedSkillIds = updatedSkills.map((skill) => skill.uuid); // Update skill IDs based on uuid

    setSkills(updatedSkills); // Update the skills array
    setSkillsId(updatedSkillIds); // Update the skillsId array
    setValue("preferred_skills", updatedSkillIds); // Reflect the updated skills in the form
  };
  const toast = useToast();

  const handleUpdate = async (jobPreferenceData) => {
    setLoading(true);

    // Log the current state before updating
    console.log("Current locations before update:", location);
    console.log("Current location IDs before update:", locationId);
    console.log("Current skills before update:", skills);
    console.log("Current skill IDs before update:", skillsId);

    const newData = {
      preferred_location: locationId.length > 0 ? locationId : [],
      preferred_skills: skillsId.length > 0 ? skillsId : [],
      department_uuid: jobPreferenceData.department_uuid,
      job_type: jobPreferenceData.job_type,
      employment_type: jobPreferenceData.employment_type,
      preferred_shift: jobPreferenceData.preferred_shift,
      expected_salary_currency: jobPreferenceData.expected_salary_currency,
      expected_salary_amount: jobPreferenceData.expected_salary_amount,
      notice_period: jobPreferenceData.notice_period,
    };

    console.log("Sending update data:", newData);

    if (jobPreferences) {
      try {
        await dispatch(
          updateJobPreferenceAsync({
            uuid: jobPreferences.uuid,
            jobPreferenceData: newData,
          })
        );
        console.log("Job preference updated successfully", newData);
        await dispatch(fetchJobPreferencesAsync());
        reset();
        onClose2();

        toast({
          title: "Job Preferences Updated",
          description: "Your job preferences have been successfully updated.",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
          variant: "solid",
        });
      } catch (error) {
        console.error(
          "Failed to update data",
          error.response ? error.response.data : error
        );

        toast({
          title: "Error",
          description:
            error.response?.data?.message ||
            "Failed to update job preferences. Please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
          variant: "solid",
        });
      } finally {
        setLoading(false);
      }
    } else {
      console.warn("JobPreference is not defined");

      toast({
        title: "Warning",
        description: "No job preference found to update.",
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  const openUpdateModal = (jobPreference) => {
    if (jobPreference) {
      setValue("job_type", jobPreference.job_type);
      setValue("employment_type", jobPreference.employment_type);
      setValue("preferred_shift", jobPreference.preferred_shift);
      setValue(
        "expected_salary_currency",
        jobPreference.expected_salary_currency
      );
      setValue("expected_salary_amount", jobPreference.expected_salary_amount);
      setValue("notice_period", jobPreference.notice_period);

      // Ensure department exists before accessing uuid
      setValue("department_uuid", jobPreference.department?.uuid || "");

      // Clear existing locations and skills
      setLocation([]);
      setLocationId([]);
      setSkills([]);
      setSkillsId([]);

      // Check if preference_location exists and is an array before mapping
      if (Array.isArray(jobPreference.preference_location)) {
        const validLocations = jobPreference.preference_location
          .map((loc) => loc.location)
          .filter(Boolean); // Remove null/undefined values

        const validLocationIds = validLocations.map((loc) => loc.uuid);

        setLocation(validLocations);
        setLocationId(validLocationIds);
        setValue("preferred_location", validLocationIds);

        console.log("Loaded locations:", validLocations);
      }

      // Check if preference_skills exists and is an array before mapping
      if (Array.isArray(jobPreference.preference_skills)) {
        const validSkills = jobPreference.preference_skills
          .map((skill) => skill.skill)
          .filter(Boolean); // Remove null/undefined values

        const validSkillIds = validSkills.map((skill) => skill.uuid);

        setSkills(validSkills);
        setSkillsId(validSkillIds);
        setValue("preferred_skills", validSkillIds);

        console.log("Loaded skills:", validSkills);
      }

      onOpen2();
    }
  };

  useEffect(() => {
    if (jobPreferences?.preference_location) {
      const locations = jobPreferences?.preference_location.map(
        (item) => item.location
      );
      setLocation(locations || []); // default to empty array if null
      setLocationId(locations.map((loc) => loc.uuid) || []); // handle null case
    } else {
      setLocation([]); // ensure arrays are always initialized
      setLocationId([]);
    }

    if (jobPreferences?.preference_skills) {
      const skills = jobPreferences?.preference_skills.map(
        (item) => item.skill
      );
      setSkills(skills || []);
      setSkillsId(skills.map((skill) => skill.uuid) || []);
    } else {
      setSkills([]);
      setSkillsId([]);
    }
  }, [jobPreferences]);

  // Add this useEffect after the other useEffects
  useEffect(() => {
    console.log("Current locations:", location);
    console.log("Current location IDs:", locationId);
  }, [location, locationId]);

  return (
    <div className="py-3">
      <div className="">
        {jobPreferences && jobPreferences.length > 0 ? (
          jobPreferences.map((jobPreference) => (
            <div key={jobPreference.id}>
              <Card padding={"2rem"}>
                <div className="flex justify-between">
                  <h4>Job Preferences</h4>
                  <Tooltip label="Edit Job Preference">
                    <Button
                      colorScheme="blue"
                      onClick={() => openUpdateModal(jobPreference)}
                    >
                      Edit Job Preference
                    </Button>
                  </Tooltip>
                </div>

                <div className="mx-2 flex my-4 flex-wrap">
                  <div className="w-full md:w-1/2 mb-4 md:mb-0 pr-0 md:pr-4">
                    <div className="text-start mb-4">
                      <h6 className="text-gray-500 font-semibold">
                        Employment Type
                      </h6>
                      <h6 className="text-blue-600 font-medium">
                        {jobPreference.employment_type}
                      </h6>
                    </div>
                    <div className="text-start mb-4">
                      <h6 className="text-gray-500 font-semibold">
                        Preferred Shift
                      </h6>
                      <h6 className="text-black font-Normal">
                        {jobPreference.preferred_shift}
                      </h6>
                    </div>
                  </div>
                  <div className="w-full md:w-1/2 pl-0 md:pl-4">
                    <div className="text-start mb-4">
                      <h6 className="text-gray-500 font-semibold">
                        Expected Salary
                      </h6>
                      <h6 className="text-blue-600 font-medium">
                        <FontAwesomeIcon size="sm" icon={faRupeeSign} />{" "}
                        {jobPreference.expected_salary_amount} LPA
                      </h6>
                    </div>
                    <div className="text-start mb-4">
                      <h6 className="text-gray-500 font-semibold">
                        Preferred location
                      </h6>
                      <h6 className="text-black font-medium">
                        {jobPreference.preference_location
                          .map((loc) => loc.location?.title)
                          .join(", ")}
                      </h6>
                    </div>
                  </div>
                </div>
                {/* <div className="text-start mb-4">
                  <h6 className="text-gray-500 font-semibold">Skills</h6>
                  <h6 className="text-black font-medium">
                    {jobPreference.preference_skills.map((skill) => skill.skill?.title).join(", ")}
                  </h6>
                </div> */}
              </Card>
            </div>
          ))
        ) : (
          <div
            className="bg-white flex flex-col"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            <Card padding={"2rem"}>
              <div className="flex justify-between">
                <h1 className="text-3xl text-left my-2 font-semibold">
                  Job Preferences
                </h1>
                <div className="py-3 flex gap-3">
                  <Button onClick={onOpen1} colorScheme="blue">
                    Add<i className="fa-solid fa-plus px-2"></i>
                  </Button>
                </div>
              </div>
              <EmptyState
                title="Job Preferences"
                icon={FaBriefcase}
                emptyMessage="Start by adding your Job Preferences"
                addButtonText="Add Job Preferences"
                onAdd={onOpen1} // Ensure this function is defined to add job preferences
              />
            </Card>
          </div>
        )}
      </div>

      <Modal isOpen={isOpen1} onClose={onClose1}>
        <ModalOverlay />
        <ModalContent
          mx={4}
          maxW="90%"
          w="auto"
          minW={{ base: "auto", md: "3xl" }}
        >
          <ModalHeader>Job Preference</ModalHeader>
          <ModalCloseButton />
          <form onSubmit={handleSubmit(handleSave)}>
            <ModalBody pb={6}>
              <FormControl mt={6}>
                <FormLabel>Job Type</FormLabel>
                <Select
                  {...register("job_type", {
                    required: "Job Type is required",
                  })}
                  mb={4}
                >
                  <option value="">Select Job Type</option>
                  <option value="Permanent">Permanent</option>
                  <option value="Fixed-Term">Fixed-Term</option>
                  <option value="Commission-Based">Commission-Based</option>
                  <option value="Volunteer">Volunteer</option>
                  <option value="Intern">Intern</option>
                </Select>
                {errors.job_type && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.job_type.message}
                  </p>
                )}
              </FormControl>

              <FormControl mt={6}>
                <FormLabel>Employment Type</FormLabel>
                <Select
                  placeholder="Select option"
                  {...register("employment_type", {
                    required: "Employment Type is required",
                  })}
                  mb={4}
                >
                  <option>Full Time</option>
                  <option>Part Time</option>
                </Select>
                {errors.employment_type && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.employment_type.message}
                  </p>
                )}
              </FormControl>

              <FormControl mt={6}>
                <FormLabel>Preferred Shift</FormLabel>
                <Select
                  placeholder="Select option"
                  {...register("preferred_shift", {
                    required: "Preferred Shift is required",
                  })}
                  mb={4}
                >
                  <option>Day</option>
                  <option>Night</option>
                  <option>Flexible</option>
                </Select>
                {errors.preferred_shift && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.preferred_shift.message}
                  </p>
                )}
              </FormControl>

              <FormControl isInvalid={!!errors.current_salary_currency}>
                <FormLabel>Current Salary Currency</FormLabel>
                <Select
                  {...register("expected_salary_currency", {
                    required: "Currency is required",
                  })}
                  defaultValue="INR"
                  placeholder="Select currency"
                >
                  <option value="INR">INR</option>
                  <option value="USD">USD</option>
                </Select>
                <FormErrorMessage>
                  {errors.current_salary_currency?.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl mt={6}>
                <FormLabel>Expected Salary (in LPA)</FormLabel>
                <Input
                  type="number"
                  placeholder="Expected Salary (in LPA)"
                  {...register("expected_salary_amount", {
                    required: "Expected Salary is required",
                  })}
                  mb={4}
                />
                {errors.expected_salary_amount && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.expected_salary_amount.message}
                  </p>
                )}
              </FormControl>

              <FormControl mt={6}>
                <FormLabel>Notice Period</FormLabel>
                <Select
                  placeholder="Notice Period"
                  {...register("notice_period", {
                    required: "Notice Period is required",
                  })}
                  mb={4}
                >
                  <option>15 Days or less</option>
                  <option>1 month</option>
                  <option>2 months</option>
                  <option>3 months</option>
                  <option>More than 3 months</option>
                  <option>Serving Notice Period</option>
                </Select>
                {errors.notice_period && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.notice_period.message}
                  </p>
                )}
              </FormControl>

              <div className="mt-4">
                <label className="mb-1 ml-1 font-semibold">Departments</label>
                <div className="border-2 rounded-lg">
                  <Select
                    placeholder="Select option"
                    {...register("department_uuid", {
                      required: "Job Department is required",
                    })}
                    mb={4}
                  >
                    {Array.isArray(jobDepartments) &&
                      jobDepartments.map((job) => (
                        <option key={job.id} value={job.uuid}>
                          {job.title}
                        </option>
                      ))}
                  </Select>
                  {errors.department_uuid && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.department_uuid.message}
                    </p>
                  )}
                </div>
              </div>

              <FormControl mb={4} mt={6}>
                <FormLabel>Preferred Location</FormLabel>
                <Select
                  className="border-black"
                  variant="outline"
                  {...register("preferred_location", {
                    required: "Preferred Location is required",
                  })}
                  onChange={handleSelectedLocation}
                  mb={4}
                >
                  <option value="">Select a location</option>
                  {coreLocation &&
                    coreLocation?.map((item) => (
                      <option key={item?.id} value={item.uuid}>
                        {item.title}
                      </option>
                    ))}
                </Select>
                {errors.preferred_location && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.preferred_location.message}
                  </p>
                )}
                {location && (
                  <div className="mt-3 w-fit flex flex-wrap gap-2">
                    {location.map((loc, index) => (
                      <div
                        key={index}
                        className="bg-blue-500 p-2 text-white  rounded"
                      >
                        {loc.title}
                        <button
                          className="ml-2 text-white hover:text-gray-300"
                          onClick={(e) => {
                            e.preventDefault(); // Prevent default button behavior
                            removeLocation(index);
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </FormControl>

              <FormControl mb={4} mt={6}>
                <FormLabel>Preferred Skills</FormLabel>
                <Select
                  className="border-black"
                  variant="outline"
                  {...register("preferred_skills", {
                    required: "Preferred Skills is required",
                  })}
                  onChange={handleSelectedSkills}
                  mb={4}
                >
                  {/* <option></option> */}
                  {coreSkills &&
                    coreSkills.map((item) => (
                      <option key={item?.id} value={item?.uuid}>
                        {item?.title}
                      </option>
                    ))}
                </Select>
                {errors.preferred_skills && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.preferred_skills.message}
                  </p>
                )}

                {skills && (
                  <div className="mt-3 w-fit flex flex-wrap gap-2">
                    {skills.map((skill, index) => (
                      <div
                        key={index}
                        className="bg-blue-500 p-2 text-white  rounded"
                      >
                        {skill?.title}
                        <button
                          className="ml-2 text-white hover:text-gray-300"
                          onClick={(e) => {
                            e.preventDefault(); // Prevent default button behavior
                            removeSkill(index);
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </FormControl>
            </ModalBody>
            <ModalFooter className="bg-logoblue">
              <Button mr={3} type="submit">
                Save
              </Button>
              <Button
                onClick={() => {
                  reset();
                  onClose1();
                }}
              >
                Cancel
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpen2} onClose={onClose2}>
        <ModalOverlay />
        <ModalContent
          mx={4}
          maxW="90%"
          w="auto"
          minW={{ base: "auto", md: "3xl" }}
        >
          <ModalHeader>Edit Job Preference</ModalHeader>
          <ModalCloseButton />
          <form onSubmit={handleSubmit(handleUpdate)}>
            <ModalBody pb={6}>
              <FormControl mt={4}>
                <FormLabel>Job Type</FormLabel>
                <Select
                  {...register("job_type", {
                    required: "Job Type is required",
                  })}
                  mb={4}
                >
                  <option value="">Select Job Type</option>
                  <option value="Permanent">Permanent</option>
                  <option value="Fixed-Term">Fixed-Term</option>
                  <option value="Commission-Based">Commission-Based</option>
                  <option value="Volunteer">Volunteer</option>
                  <option value="Intern">Intern</option>
                </Select>
                {errors.job_type && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.job_type.message}
                  </p>
                )}
              </FormControl>

              <FormControl mt={6}>
                <FormLabel>Employment Type</FormLabel>
                <Select
                  placeholder="Select option"
                  {...register("employment_type", {
                    required: "Employment Type is required",
                  })}
                  mb={4}
                >
                  <option>Full Time</option>
                  <option>Part Time</option>
                </Select>
                {errors.employment_type && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.employment_type.message}
                  </p>
                )}
              </FormControl>

              <FormControl mt={6}>
                <FormLabel>Preferred Shift</FormLabel>
                <Select
                  placeholder="Select option"
                  {...register("preferred_shift", {
                    required: "Preferred Shift is required",
                  })}
                  mb={4}
                >
                  <option>Day Shift</option>
                  <option>Night Shift</option>
                  <option>Flexible</option>
                </Select>
                {errors.preferred_shift && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.preferred_shift.message}
                  </p>
                )}
              </FormControl>

              <FormControl mt={6}>
                <FormLabel>Salary Currency</FormLabel>
                <Select
                  {...register("expected_salary_currency", {
                    required: "Expected Salary Currency is required",
                  })}
                  defaultValue="INR"
                  placeholder="Select currency"
                >
                  <option value="INR">INR</option>
                  <option value="USD">USD</option>
                </Select>
                {errors.expected_salary_currency && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.expected_salary_currency.message}
                  </p>
                )}
              </FormControl>

              <FormControl mt={6}>
                <FormLabel>Expected Salary (in LPA)</FormLabel>
                <Input
                  type="number"
                  placeholder="Expected Salary (in LPA)"
                  {...register("expected_salary_amount", {
                    required: "Expected Salary is required",
                  })}
                  mb={4}
                />
                {errors.expected_salary_amount && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.expected_salary_amount.message}
                  </p>
                )}
              </FormControl>
              <FormControl mb={4} mt={6}>
                <FormLabel>Preferred Location</FormLabel>
                <Select
                  className="border-black"
                  variant="outline"
                  {...register("preferred_location", {
                    required: "Preferred Location is required",
                  })}
                  onChange={handleSelectedLocation}
                  mb={4}
                >
                  <option value="">Select a location</option>
                  {coreLocation &&
                    coreLocation?.map((item) => (
                      <option key={item?.id} value={item.uuid}>
                        {item.title}
                      </option>
                    ))}
                </Select>
                {errors.preferred_location && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.preferred_location.message}
                  </p>
                )}
                {location && location.length > 0 && (
                  <div className="mt-3 w-fit flex flex-wrap gap-2">
                    <p className="w-full text-sm font-medium mb-2">
                      Selected Locations:
                    </p>
                    {location.map((loc, index) => (
                      <div
                        key={index}
                        className="bg-blue-500 p-2 text-white rounded flex items-center"
                      >
                        {loc.title}
                        <button
                          className="ml-2 text-white hover:text-gray-300"
                          onClick={(e) => {
                            e.preventDefault(); // Prevent default button behavior
                            removeLocation(index);
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </FormControl>
              <FormControl mb={4} mt={6}>
                <FormLabel>Preferred Skills</FormLabel>
                <Select
                  className="border-black"
                  variant="outline"
                  {...register("preferred_skills", {
                    required: "Preferred Skills is required",
                  })}
                  onChange={handleSelectedSkills}
                  mb={4}
                >
                  <option value="">Select a skill</option>
                  {coreSkills &&
                    coreSkills.map((item) => (
                      <option key={item?.id} value={item?.uuid}>
                        {item?.title}
                      </option>
                    ))}
                </Select>
                {errors.preferred_skills && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.preferred_skills.message}
                  </p>
                )}

                {skills && skills.length > 0 && (
                  <div className="mt-3 w-fit flex flex-wrap gap-2">
                    <p className="w-full text-sm font-medium mb-2">
                      Selected Skills:
                    </p>
                    {skills.map((skill, index) => (
                      <div
                        key={index}
                        className="bg-blue-500 p-2 text-white rounded flex items-center"
                      >
                        {skill?.title}
                        <button
                          className="ml-2 text-white hover:text-gray-300"
                          onClick={(e) => {
                            e.preventDefault(); // Prevent default button behavior
                            removeSkill(index);
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </FormControl>
            </ModalBody>
            {loading && <SpinnerLoad />}
            <ModalFooter className="bg-logoblue">
              <Button mr={3} type="submit">
                Save
              </Button>
              <Button onClick={onClose2}>Cancel</Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </div>
  );
}

export default JobPreferences;
